import { Monitor, Moon, Sun } from "lucide-mui";
import Box from "@mui/material/Box";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Tooltip from "@mui/material/Tooltip";
import { useColorScheme } from "@mui/material/styles";

const MODES = [
  { value: "light", label: "Light", icon: <Sun /> },
  { value: "dark", label: "Dark", icon: <Moon /> },
  { value: "system", label: "System", icon: <Monitor /> },
] as const;

interface ThemeModeToggleProps {
  /** Icons only, with tooltips (the account menu); otherwise icon and label. */
  compact?: boolean;
}

/** Light, dark or follow the system: this browser's colour scheme. */
export default function ThemeModeToggle({ compact = false }: ThemeModeToggleProps) {
  const { mode, setMode } = useColorScheme();
  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={mode ?? "system"}
      onChange={(_, next) => next && setMode(next)}
      aria-label="Theme"
      sx={{
        "& .MuiToggleButton-root": {
          px: compact ? 0.75 : 1.25,
          py: 0.375,
          gap: 0.75,
          border: "none",
          borderRadius: "6px !important",
          textTransform: "none",
        },
        "& .MuiToggleButton-root.Mui-selected": { bgcolor: "action.selected", color: "text.primary" },
        bgcolor: "action.hover",
        borderRadius: 2,
        p: 0.25,
        gap: 0.25,
      }}
    >
      {MODES.map((m) => {
        const button = (
          <ToggleButton key={m.value} value={m.value} aria-label={m.label}>
            <Box component="span" sx={{ display: "flex", "& svg": { fontSize: 15 } }}>
              {m.icon}
            </Box>
            {!compact && m.label}
          </ToggleButton>
        );
        return compact ? (
          <Tooltip key={m.value} title={m.label} disableInteractive>
            {button}
          </Tooltip>
        ) : (
          button
        );
      })}
    </ToggleButtonGroup>
  );
}
